import type { FC, ReactNode } from 'react'
import { Alert, AlertTitle } from '@mui/material'

type Variant = 'success' | 'warning'

type Props = {
  variant: Variant
  children: ReactNode
}

const severityMap: Record<Variant, 'success' | 'warning'> = {
  success: 'success',
  warning: 'warning',
} as const

const titleMap: Record<Variant, string> = {
  success: '順調です',
  warning: '重要',
} as const

export const ProfileViewAlertContainer: FC<Props> = ({ children, variant }) => {
  return (
    <Alert severity={severityMap[variant]} variant="outlined">
      <AlertTitle>{titleMap[variant]}</AlertTitle>
      {children}
    </Alert>
  )
}
